import React, { Component } from 'react'
import { Layout, Row, Col, Icon } from 'antd'

export default class Details extends Component<any, any> {
    state = {
        open: false
    }
    toggleVisibility = () => {
        this.setState(prevState => ({ open: !prevState.open }))
    }
    render() {
        const { open } = this.state
        const { name, general_indication, description, health_condition, source_id } = this.props
        return (
            <div style={{ cursor: 'pointer' }} onClick={() => this.toggleVisibility()}>
                <div style={{ textDecoration: 'underline' }}>
                    <Icon type={open ? 'down' : 'left'} style={{ fontSize: '0.8rem', marginLeft: '0.5rem' }} />
                    <span>{name}</span>
                </div>
                <div
                    style={{
                        display: `${this.state.open ? 'flex' : 'none'}`,
                        paddingRight: '1.5rem',
                        flexDirection: 'column'
                    }}
                >
                    <div style={{ opacity: `${description ? '1' : '0.3'}` }}>
                        <strong>תיאור:</strong>
                        {description ? (
                            <div
                                style={{ maxHeight: '20vh', overflow: 'auto' }}
                                dangerouslySetInnerHTML={{ __html: description }}
                            />
                        ) : (
                            '--'
                        )}
                    </div>
                    <div style={{ opacity: `${health_condition ? '1' : '0.3'}` }}>
                        <strong>מצב בריאות: </strong> {health_condition ? health_condition : '--'}
                    </div>
                    <div style={{ opacity: `${general_indication ? '1' : '0.3'}` }}>
                        <strong>אינדיקציה כללית: </strong>
                        {general_indication ? general_indication : '--'}
                    </div>
                </div>
            </div>
        )
    }
}
